
import React from "react";
import { Link } from "react-router-dom";
import { Icons } from "@/components/icons";

interface HeaderLogoProps {
  className?: string;
}

const HeaderLogo = ({ className = "" }: HeaderLogoProps) => {
  return (
    <Link to="/" className={`flex items-center font-semibold gap-1.5 sm:gap-2 ${className}`}>
      <Icons.logo className="h-5 w-5 sm:h-6 sm:w-6 flex-shrink-0" />
      <span className="whitespace-nowrap text-sm sm:text-base">Discovery Hub</span>
    </Link>
  );
};

export default HeaderLogo;
